import ApiService from "../api-service";

class SupportApiService extends ApiService {
  sendRequest = async (data) =>
    await this.post("/support/request", data).then((res) => res.data);
}

const SupportApi = new SupportApiService("common");

export { SupportApi };
